import { z } from 'zod'

import { dexpiTextSchema } from './dexpiAttributes'

const pipeClassSchema = z.enum([
  'Plant.Piping.Pipe',
  'Plant.Piping.DirectPipingConnection',
])
const twoPortComponentClassSchema = z.enum([
  'Plant.Piping.OperatedValve',
  'Plant.Piping.GateValve',
  'Plant.Piping.GlobeValve',
  'Plant.Piping.BallValve',
  'Plant.Piping.ButterflyValve',
  'Plant.Piping.PlugValve',
  'Plant.Piping.NeedleValve',
  'Plant.Piping.StraightwayValve',
  'Plant.Piping.PipeReducer',
  'Plant.Piping.Strainer',
  'Plant.Piping.ConicalStrainer',
  'Plant.Piping.Compensator',
  'Plant.Piping.FlangedConnection',
  'Plant.Piping.Hose',
])
const nozzleClassSchema = z.enum([
  'Plant.ProcessEquipment.Nozzle',
  'Plant.ProcessEquipment.ProcessNozzle',
])

const offPageConnectorSchema = z.object({
  dexpi_class: z.enum([
    'Plant.Piping.FlowInPipeOffPageConnector',
    'Plant.Piping.FlowOutPipeOffPageConnector',
  ]),
  attributes: z.object({ PipeConnectorNumber: dexpiTextSchema }),
})
const referenceByNumberSchema = z.object({
  dexpi_class: z.literal('Plant.Piping.PipeOffPageConnectorReferenceByNumber'),
  attributes: z.object({
    ReferencedDrawingNumber: dexpiTextSchema,
    ReferencedConnectorNumber: dexpiTextSchema,
  }),
})
const segmentSchema = z.object({
  dexpi_class: z.literal('Plant.Piping.PipingNetworkSegment'),
  attributes: z.object({
    FlowDirection: z
      .enum(['SingleFlowPipingNetworkSegment', 'DualFlowPipingNetworkSegment'])
      .optional()
      .catch(undefined),
  }),
})
const classOnlySchema = z.object({
  dexpi_class: z.enum([
    ...pipeClassSchema.options,
    ...twoPortComponentClassSchema.options,
    ...nozzleClassSchema.options,
    'Plant.Piping.PipingNode',
    'Plant.Piping.PipeTee',
    'Plant.Piping.PipingNetworkSystem',
    'Plant.Piping.PipeOffPageConnectorObjectReference',
    'Plant.ProcessEquipment.Chamber',
  ]),
})

export const dexpiNodeSchema = z.union([
  z.discriminatedUnion('dexpi_class', [
    offPageConnectorSchema,
    referenceByNumberSchema,
    segmentSchema,
    classOnlySchema,
  ]),
  z.object({}).transform(() => ({ dexpi_class: 'Unsupported' as const })),
])
export type DexpiNode = z.infer<typeof dexpiNodeSchema>
export type DexpiClass = DexpiNode['dexpi_class']

export const pipeClasses = new Set<DexpiClass>(pipeClassSchema.options)
export const twoPortComponentClasses = new Set<DexpiClass>(
  twoPortComponentClassSchema.options
)
export const nozzleClasses = new Set<DexpiClass>(nozzleClassSchema.options)
